import { AndroidIcon, AppleIcon, DesktopIconFilled } from '@karma/components/icons';
import { Typography } from '@karma/components';
import { DEVICE_TYPES } from 'consts/karmaEarn';
import { Container } from './KarmaEarnPlatforms.style';

const EMPTY_DEVICES = [];

const KarmaEarnPlatforms = ({ devices = EMPTY_DEVICES }) => {
  const hasAndroid = devices.some(({ device }) => device === DEVICE_TYPES.ANDROID);
  const hasIos = devices.some(({ device }) => device === DEVICE_TYPES.IOS);
  const hasWeb = devices.some(({ device }) => device === DEVICE_TYPES.WEB);

  return (
    <Container>
      {hasAndroid && <AndroidIcon size="extraSmall" style={{ color: '#aac248' }} />}
      {hasIos && <AppleIcon size="extraSmall" color="color11" />}
      {hasWeb && <DesktopIconFilled size="extraSmall" />}

      {devices.length === 1 && (
        <Typography variant="paragraphSmall">
          {hasAndroid && 'Android'}
          {hasIos && 'iOS'}
          {hasWeb && 'Desktop'}
        </Typography>
      )}
    </Container>
  );
};

export default KarmaEarnPlatforms;
